import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { ModalModule } from '@hdms/shared/ui-core';

import { ContactBodyModule } from '../contact-body/contact-body.module';
import { ContactFooterModule } from '../contact-footer/contact-footer.module';
import { ContactHeaderModule } from '../contact-header/contact-header.module';

import { ContactModalComponent } from './contact-modal.component';

@NgModule({
  declarations: [ContactModalComponent],
  imports: [CommonModule, ContactBodyModule, ContactHeaderModule, ContactFooterModule, ModalModule, TranslationModule],
  exports: [ContactModalComponent]
})
export class ContactModalModule {}
